define([
	"dojo/_base/declare",
	"csi/table/Delete",
	"SiteAdmin/Locale"
], function(declare,DeleteController,Locale) {

	return declare(DeleteController, {

		toWriter: function() {

			// in order to update LocaleConfiguration.Types when deleting the custom attribute
			// call to WriterLocale that will empty the localization fields
			this.toWriterLocale();

			// everything else can be set as usual
			this.inherited(arguments);

		},

		toWriterLocale: function() {
			var	nodeCA = this.getNode();

			if (nodeCA) {
				var id = Locale.getConfigurableAttributeId(nodeCA);
				var typeClass = Locale.getConfigurableAttributeType(nodeCA);

				var	w = this.m_writer;

				// in order to delete custom attribute localization from LocaleConfiguration.types,
				// empty the value
				// small optimization: first check whether the attribute localization exists
				if(Locale.getTypeAttributeResource(typeClass, id)){
					Locale.setResource(w, Locale.ATTR_TYPES, [typeClass, Locale.TYPE_ATTR, id], "", null, true);
				}

				if(Locale.getTypeAttributeResource(typeClass, id+Locale.TOOLTIP)){
					Locale.setResource(w, Locale.ATTR_TYPES, [typeClass, Locale.TYPE_ATTR, id+Locale.TOOLTIP], "", null, true);
				}

				if(Locale.getTypeAttributeResource(typeClass, id+Locale.ATTR_VALIDATION)){
					Locale.setResource(w, Locale.ATTR_TYPES, [typeClass, Locale.TYPE_ATTR, id+Locale.ATTR_VALIDATION], "", null, true);
				}
			}


		}

	});
});